import {Component, OnDestroy, OnInit} from '@angular/core';
import {AppService} from '../app.service';
import {Zalozka} from '../model/zalozka';
import {Subscription} from 'rxjs';

@Component({
    selector: 'app-zalozky',
    templateUrl: './zalozky.component.html',
    styleUrls: ['./zalozky.component.css'],
    standalone: false
})
export class ZalozkyComponent implements OnInit, OnDestroy {

  zalozky: Zalozka[] = [];
  zalozkySubscription: Subscription;
  show = true;
  loading = true;

  constructor(private appService: AppService) { }

  ngOnInit() {
    this.zalozkySubscription = this.appService.zalozkySubject
      .subscribe((data) => {
        this.zalozky = data;
        this.loading = false;
      });

    this.appService.fetchZalozky();
  }

  ngOnDestroy(): void {
    this.zalozkySubscription.unsubscribe();
  }

}
